import React, { useState, useEffect } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

function Clientprofile() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
  });

  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [data, setData] = useState(null);
  const [username, setUsername] = useState("");

  // Check if the user is authenticated and has the correct role
  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    }
  }, []);

  // Decode token and set user information
  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email || decoded.phoneNumber);
      setRole(decoded.role);
      if (decoded.role !== "client") {
        navigate("/login");
      }
    }
  }, []);

  // Fetch admin details based on username
  useEffect(() => {
    axios
      .get(`https://api.easytaxexperts.com/get/clientprofile/${username}`)
      .then((response) => {
        setData(response.data);
        if (response.data && response.data.length > 0) {
          setFormData({
            userName: response.data[0].userName || "",
            email: response.data[0].email || "",
            phoneNumber: response.data[0].phoneNumber || "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [username]);

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <h4>My Profile Details</h4>
          <form>
            <div className="form-group mt-3">
              <label>User Name:</label>
              <input
                type="text"
                value={formData.userName}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group mt-3">
              <label>Email:</label>
              <input
                type="email"
                value={formData.email}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group mt-3">
              <label>Phone Number:</label>
              <input
                type="text"
                value={formData.phoneNumber}
                readOnly
                className="form-control"
              />
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default Clientprofile;
